import React, { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CaretDownIcon } from '@phosphor-icons/react';
import type { DispensationItem } from '../../../types';
import styles from './DispensationListItem.module.css';

interface DispensationListItemProps {
    item: DispensationItem;
}

const DispensationListItem: React.FC<DispensationListItemProps> = ({ item }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const contentId = useId();

    const showBeskrivelse = item.beskrivelse && item.beskrivelse !== item.tittel;

    return (
        <li className={`${styles.item} ${open ? styles.open : ''}`}>
            <button
                type="button"
                className={styles.trigger}
                aria-expanded={open}
                aria-controls={contentId}
                onClick={() => setOpen(o => !o)}
            >
                <span className={styles.headingGroup}>
                    <span className={styles.itemTitle}>{item.tittel}</span>
                    <span className={styles.itemMeta}>
                        {item.saksnummer}
                        {item.dato ? ` ${item.dato}` : ''}
                    </span>
                </span>
                <CaretDownIcon
                    size={20}
                    className={`${styles.indicator} ${open ? styles.indicatorOpen : ''}`}
                    aria-hidden
                />
            </button>
            <dl id={contentId} role="region" aria-label={item.tittel} hidden={!open} className={styles.panel}>
                <div className={styles.row}>
                    <dt>{t('dispensations.fields.dispensasjonType')}</dt>
                    <dd>{item.dispensasjonTypeLabel || '–'}</dd>
                </div>
                <div className={styles.row}>
                    <dt>{t('dispensations.fields.dispensasjonFra')}</dt>
                    <dd>{item.dispensasjonFraLabel || '–'}</dd>
                </div>
                <div className={styles.row}>
                    <dt>{t('dispensations.detail.varighet')}</dt>
                    <dd>{item.varighet || '–'}</dd>
                </div>
                {item.begrunnelse && (
                    <div className={styles.row}>
                        <dt>{t('dispensations.fields.begrunnelse')}</dt>
                        <dd>{item.begrunnelse}</dd>
                    </div>
                )}
                {showBeskrivelse && (
                    <div className={styles.row}>
                        <dt>{t('dispensations.fields.beskrivelse')}</dt>
                        <dd>{item.beskrivelse}</dd>
                    </div>
                )}
            </dl>
        </li>
    );
};

export default DispensationListItem;
